// src/components/Dispatchdetails/EditDispatchdetails.jsx
import React, { useEffect, useMemo, useRef, useState } from "react";
import { db } from "../../firebase";
import {
  collection,
  doc,
  getDoc,
  updateDoc,
  arrayUnion,
} from "firebase/firestore";
import {
  Box,
  Button,
  Divider,
  TextField,
  Card,
  CardHeader,
  CardContent,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  CircularProgress,
  Grid2,
  LinearProgress,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import PrintIcon from "@mui/icons-material/Print";
import { format } from "date-fns";
import { useNavigate, useParams } from "react-router-dom";
import EditOrderFrom from "./EditOrderFrom";
import ReusableFormExceptions from "../ReusableFormExceptions/ReusableFormExceptions";
import { useOrders } from "../../hooks/useOrdersProviders/OrdersContext";
import Moment from "moment";
import {
  getDocumentAndHistory,
  subscribeDocumentAndHistory,
} from "../../utils/UtilsOrders/getDocumentAndHistory";
import useGetDataRiderByCompany from "../../hooks/getDataRiderByCompany";
import {
  translateStatesBicciFilter,
  translateStatesfalabbela,
  translateStatesSendsFalabbelaSelector,
} from "../../utils/objects/translateStates";
import EditRoutePosition from "../EditRoutePosition/EditRoutePosition";
import PopUpAsignament from "../PopUpAsignament/PopUpAsignament";
import LiberarOrden from "../Dashboard/LiberarOrden/LiberarOrden";
import {
  stlyleClassStates,
  styleState,
} from "../../utils/objects/stylesStates";
import ContainerViewComponent from "../ContainerViewComponent/ContainerViewComponent";
import MapDeliveryPosition from "./MapDeliveryPosition";
import HandlePrintBiccShipping from "../../utils/HandlePrintBiccShipping/HandlePrintBiccShipping";
import { useLoadScript } from "@react-google-maps/api";
import { obtenerHistorialDeOrden } from "../../hooks/useOrdersProviders/obtenerHistorialDeOrden";

const companyId = "77528497-8";
const libraries = ["places", "geometry"];
const COMPUTETIME = true;

const SectionLoader = ({ text = "Cargando..." }) => (
  <Box sx={{ display: "flex", alignItems: "center", gap: 1, py: 1 }}>
    <LinearProgress sx={{ flex: 1 }} />
    <Typography variant="body2" color="text.secondary">
      {text}
    </Typography>
  </Box>
);

const EditDispatchdetails = (props) => {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_APIGOOGLEMAPS_MATRIX,
    libraries,
  });
  const navigate = useNavigate();
  const { id } = useParams();

  // --- Principales
  const [orderId, setOrderId] = useState("");
  const [orderDetails, setOrderDetails] = useState(null);
  const [orderDetailsCliente, setOrderDetailsCliente] = useState(null);
  const [dispachtHistory, setDispachtHistory] = useState([]);
  const [compyOrder, setCompyOrder] = useState({});
  const [dataOrdesBicciExpress, setDataOrdesBicciExpress] = useState([]);

  // --- Soporte
  const [isSending, setIsSending] = useState(false);
  const [findOrder, setFindOrder] = useState(null);

  // --- Comentarios
  const [userAdminComent, setUserAdminComent] = useState([]);
  const [newComent, setNewComent] = useState("");

  // --- Excepciones / asignación
  const [openEdit, setOpenEdit] = useState(false);
  const [opemPopUpAsignament, setOpemPopUpAsignament] = useState(false);

  // --- Rider / acciones en grupo
  const [riderDestails, setRiderDetails] = useState({});
  const [routesOrdersForAccions, setRoutesOrdersForAccions] = useState([]);

  // --- Prefijos
  const [prefixes, setPrefixes] = useState([]);
  const [orderPrefix, setOrderPrefix] = useState(null);
  const orderPrefixRef = useRef(null);

  // --- Suscripción viva
  const unsubscribeRef = useRef(null);

  // --- Estados de carga por sección (no bloqueantes)

  // Hooks personalizados
  const initDateInitial = Moment().format("YYYY-MM-DD");
  const endDateInitial = Moment().format("YYYY-MM-DD");
  const { companiesData } = useOrders({ initDateInitial, endDateInitial });
  const { ridersDataByCompany } = useGetDataRiderByCompany(companyId);

  // --- Estados de carga por sección (no bloqueantes)
  const [docReady, setDocReady] = useState(false);
  const [companyReady, setCompanyReady] = useState(false);
  const [historyReady, setHistoryReady] = useState(false);
  const [ridersReady, setRidersReady] = useState(false);

  // --- Métrica de tiempo de carga total (dev only)
  const tStartRef = useRef(Date.now());
  const [loadDoneAt, setLoadDoneAt] = useState(null);
  const [elapsedSec, setElapsedSec] = useState(0);
  const [xlogs, setXlogs] = useState([]);

  // Marca de “todo listo”: ajusta esta condición si quieres incluir/excluir secciones
  const allReady =
    docReady && companyReady && historyReady && ridersReady && isLoaded;

  // Riders O(1) para historial
  const ridersById = useMemo(() => {
    const map = new Map();
    if (ridersDataByCompany?.length) {
      ridersDataByCompany.forEach((r) => map.set(r.id, r));
    }
    setRidersReady(true);
    return map;
  }, [ridersDataByCompany]);

  function handleClick() {
    navigate(-1);
  }

  // Cuando todo pase a listo por primera vez, fija el tiempo final
  useEffect(() => {
    if (!COMPUTETIME) return;
    if (!loadDoneAt && allReady) {
      const t = Date.now();
      setLoadDoneAt(t);
      setElapsedSec((t - tStartRef.current) / 1000);
    }
  }, [allReady, loadDoneAt]);

  // Mientras no termina, actualiza el cronómetro en vivo
  useEffect(() => {
    if (!COMPUTETIME) return;
    if (loadDoneAt) return; // ya terminó

    const id = setInterval(() => {
      setElapsedSec((Date.now() - tStartRef.current) / 1000);
    }, 200);

    return () => clearInterval(id);
  }, [loadDoneAt]);

  // Prefijos desde compañías (sección independiente)
  useEffect(() => {
    if (companiesData?.length > 0) {
      const extracted = companiesData
        .filter((item) => item.prefix)
        .map((item) => item.prefix);
      setPrefixes(extracted);
      if (extracted.length > 0) setCompanyReady(true);
    }
  }, [companiesData]);

  // ID desde URL
  useEffect(() => {
    if (!id) return;
    const trimmedId = id.trim();
    setOrderId(trimmedId);
    setRoutesOrdersForAccions((prev) =>
      prev.includes(trimmedId) ? prev : [trimmedId]
    );
  }, [id]);

  // Bootstrap + Suscripción viva (secciones desacopladas)
  useEffect(() => {
    if (!orderId || prefixes.length === 0) return;

    getXpressLogs();

    let cancelled = false;
    const collections = [process.env.REACT_APP_COL_USERS_ORDERS];

    (async () => {
      try {
        setDocReady(false);
        setHistoryReady(false);

        const { foundDocumentData, documentHistory, prefix } =
          await getDocumentAndHistory(orderId, prefixes, collections, {
            historyLimit: 30,
            companiesData,
            altCollection: process.env.REACT_APP_COL_FALABELLA_ORDERS,
            mainHistorySub: "statuses",
            altHistorySub: "status",
            falabellaPrefix: "F",
          });

        if (cancelled) return;

        if (prefix) {
          if (orderPrefixRef.current !== prefix) {
            orderPrefixRef.current = prefix;
            setOrderPrefix(prefix);
          }
          const dataCompany = companiesData?.find?.((c) => c.prefix === prefix);
          if (dataCompany) {
            if (dataCompany.companyID === "90749000-9") {
              dataCompany.nonDelivery = translateStatesSendsFalabbelaSelector;
            }
            setCompyOrder((prev) =>
              prev?.companyID === dataCompany.companyID ? prev : dataCompany
            );
            setCompanyReady(true);
          }
        }

        if (foundDocumentData?.id) {
          setOrderDetails(foundDocumentData);
          setOrderDetailsCliente(foundDocumentData);
          setFindOrder(true);
          setDocReady(true);
        } else {
          setFindOrder(false);
        }

        if (Array.isArray(documentHistory)) {
          setDispachtHistory(documentHistory);
          setHistoryReady(true);
        }

        // listeners vivos
        if (unsubscribeRef.current) {
          try {
            unsubscribeRef.current();
          } catch {}
          unsubscribeRef.current = null;
        }

        unsubscribeRef.current = await subscribeDocumentAndHistory(
          orderId,
          prefixes,
          collections,
          ({ doc, history, prefix: livePrefix }) => {
            if (doc && doc.id) {
              setOrderDetails(doc);
              setOrderDetailsCliente(doc);
              setFindOrder(true);
              setDocReady(true);
            } else {
              setFindOrder(false);
            }

            if (Array.isArray(history)) {
              setDispachtHistory(history);
              setHistoryReady(true);
            }

            if (livePrefix && livePrefix !== orderPrefixRef.current) {
              orderPrefixRef.current = livePrefix;
              setOrderPrefix(livePrefix);
              const dataCompany = companiesData?.find?.(
                (c) => c.prefix === livePrefix
              );
              if (dataCompany) {
                if (dataCompany.companyID === "90749000-9") {
                  dataCompany.nonDelivery =
                    translateStatesSendsFalabbelaSelector;
                }
                setCompyOrder(dataCompany);
                setCompanyReady(true);
              }
            }
          },
          {
            historyLimit: 30,
            altCollection: process.env.REACT_APP_COL_FALABELLA_ORDERS,
            altHistorySub: "status",
            mainHistorySub: "statuses",
            falabellaPrefix: "F",
            companiesData,
          }
        );
      } catch (err) {
        console.error("bootstrap+subscribe error:", err);
        setFindOrder(false);
      }
    })();

    return () => {
      cancelled = true;
      if (unsubscribeRef.current) {
        try {
          unsubscribeRef.current();
        } catch {}
        unsubscribeRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId, prefixes, companiesData]);

  // Cargar rider al cambiar driverID (independiente)
  useEffect(() => {
    let mounted = true;
    const fetchRiderDetails = async (driverId) => {
      try {
        if (!driverId) return;
        const docRef = doc(
          db,
          process.env.REACT_APP_COL_USERS_DRIVERS,
          driverId
        );
        const riderRef = await getDoc(docRef);
        if (!mounted) return;
        setRiderDetails(riderRef.data() || {});
      } catch (error) {
        console.error("Error al obtener detalles del rider:", error);
      }
    };

    if (orderDetails?.driverID) {
      fetchRiderDetails(orderDetails.driverID);
      const trimmedId = (orderDetails.id || "").trim();
      if (trimmedId) {
        setRoutesOrdersForAccions((prev) =>
          prev.includes(trimmedId) ? prev : [trimmedId]
        );
      }
    } else {
      setRiderDetails({});
    }

    return () => {
      mounted = false;
    };
  }, [orderDetails?.driverID, orderDetails?.id]);

  // Validar recolección de orden
  const saveValidatePickup = async () => {
    if (!orderDetails?.isPickedUp && orderId) {
      try {
        setIsSending(true);
        const orderRef3 = doc(
          db,
          process.env.REACT_APP_COL_USERS_ORDERS,
          orderId
        );
        await updateDoc(orderRef3, { isPickedUp: true });
      } catch (error) {
        console.log("Error al actualizar el documento:", error);
      } finally {
        setIsSending(false);
      }
    }
  };

  const getXpressLogs = async () => {
    let xlog = await obtenerHistorialDeOrden(orderId);
    setXlogs(xlog);
  };

  // Guardar comentario admin (optimista + arrayUnion)
  const saveComentAdmin = async (e) => {
    e.preventDefault();
    const text = newComent.trim();
    if (!text || !orderId) return;

    try {
      setIsSending(true);
      const orderRef3 = doc(
        db,
        process.env.REACT_APP_COL_USERS_ORDERS,
        orderId
      );
      await updateDoc(orderRef3, { observationAdmin: arrayUnion(text) });
      setUserAdminComent((prev) => [...(prev || []), text]);
      setNewComent("");
    } catch (err) {
      console.error("saveComentAdmin:", err);
    } finally {
      setIsSending(false);
    }
  };

  // Guardar en modal de excepciones
  // const onSave = async () => {
  //   try {
  //     setIsSending(true);
  //     await new Promise((r) => setTimeout(r, 250));
  //     setOpenEdit(false);
  //   } catch (e) {
  //     console.error(e);
  //   } finally {
  //     setIsSending(false);
  //   }
  // };
  const onSave = (payload) => {
    setIsSending(false);

    if (!payload) return;

    const exceptionId =
      payload.exceptionID || payload.reasonCode || payload.status;

    setXlogs((prev) => [
      ...prev,
      {
        id: `${orderId}-${Date.now()}`,
        date: new Date(),
        name: props.firebaseUser?.displayName || "",
        exceptionID: exceptionId,
        status: payload.status,
      },
    ]);
  };

  // Refresh manual no bloqueante
  const handleUpdate = async () => {
    try {
      setDocReady(false);
      setHistoryReady(false);
      const collections = [process.env.REACT_APP_COL_USERS_ORDERS];
      const { foundDocumentData, documentHistory } =
        await getDocumentAndHistory(orderId, prefixes, collections, {
          historyLimit: 30,
          companiesData,
          altCollection: process.env.REACT_APP_COL_FALABELLA_ORDERS,
          mainHistorySub: "statuses",
          altHistorySub: "status",
          falabellaPrefix: "F",
        });
      if (foundDocumentData?.id) {
        setOrderDetails(foundDocumentData);
        setOrderDetailsCliente(foundDocumentData);
        setFindOrder(true);
        setDocReady(true);
      }
      setDispachtHistory(documentHistory || []);
      setHistoryReady(true);
    } catch (e) {
      console.error("handleUpdate:", e);
      setDocReady(true);
      setHistoryReady(true);
    }
  };

  const formatDate = (ts) => {
    if (!ts) return "-";
    // Firestore Timestamp → Date
    const d = ts.toDate ? ts.toDate() : ts;
    return d.toLocaleString("es-CL");
  };

  // Top bar solo para escrituras
  const showTopProgress = isSending;

  let latDriver = null;

  return (
    <div>
      {showTopProgress && (
        <Box sx={{ position: "sticky", top: 0, zIndex: 2000 }}>
          <LinearProgress />
        </Box>
      )}

      {COMPUTETIME && (
        <Box
          sx={{
            position: "fixed",
            left: 8,
            bottom: 20,
            zIndex: 3000,
            bgcolor: "rgba(0,0,0,0.72)",
            color: "#fff",
            px: 1,
            py: 0.5,
            borderRadius: 1,
            fontSize: 12,
            fontFamily: "monospace",
            pointerEvents: "none",
            boxShadow: 3,
          }}
        >
          {loadDoneAt ? "Load: " : "Cargando… "}
          {elapsedSec.toFixed(2)}s
        </Box>
      )}

      {orderDetails ? (
        <>
          <div id="containerDetails">
            {ridersDataByCompany ? (
              <PopUpAsignament
                opemPopUpAsignament={opemPopUpAsignament}
                setOpemPopUpAsignament={setOpemPopUpAsignament}
                ordersForAccions={routesOrdersForAccions}
                ridersDataByCompany={ridersDataByCompany}
                handleUpdate={handleUpdate}
              />
            ) : null}

            <Grid2>
              <Grid2 container spacing={2} sx={{ p: 1 }}>
                {/* Columna izquierda */}
                <Grid2 sx={{ width: { xs: "100%", sm: "100%", md: "65%" } }}>
                  <Card className="card-ultimasOrdenes typeMiniforms">
                    <CardHeader
                      title={
                        <Box
                          sx={{
                            width: "100%",
                            p: 1,
                            align: "left",
                            justifyContent: "start",
                          }}
                        >
                          <Typography
                            sx={{ color: "#030303", fontSize: "1.5em" }}
                          >
                            Editar Orden
                          </Typography>
                          <Divider />
                          <Typography
                            variant="h4"
                            align="left"
                            sx={{ mb: 2, fontWeight: "bold" }}
                          >
                            {orderDetails.id}
                          </Typography>

                          {!docReady ? (
                            <SectionLoader text="Cargando estados..." />
                          ) : (
                            <Grid2
                              container
                              spacing={2}
                              alignItems="left"
                              justifyContent="start"
                            >
                              {/* Estado BICCI */}
                              <Grid2 xs={12} sm={6} md={4} textAlign="center">
                                <Typography
                                  variant="h6"
                                  sx={{
                                    backgroundColor: "#F3F3F3",
                                    borderRadius: "5px",
                                    fontWeight: "bold",
                                    fontSize: "1rem",
                                    padding: "5px",
                                    color: "#333",
                                  }}
                                  className={
                                    stlyleClassStates[orderDetails.status]
                                  }
                                >
                                  {
                                    translateStatesBicciFilter[
                                      orderDetails.status
                                    ]
                                  }
                                </Typography>
                              </Grid2>

                              {orderDetails.status !== 8 ? (
                                <>
                                  {/* Estado Falabella */}

                                  {/* Botón de Validación */}
                                  <Grid2 xs={12} md={4} textAlign="center">
                                    <Button
                                      fullWidth
                                      variant="contained"
                                      onClick={() => {
                                        const confirmAction = window.confirm(
                                          "¿Estás seguro de que quieres validar que posees el producto físico?"
                                        );
                                        if (confirmAction) {
                                          saveValidatePickup();
                                        }
                                      }}
                                      disabled={
                                        orderDetails.isPickedUp || isSending
                                      }
                                      sx={{
                                        backgroundColor: orderDetails.isPickedUp
                                          ? "green"
                                          : "orange",
                                        color: "white",
                                        fontWeight: "bold",
                                        fontSize: "1rem",
                                        padding: "10px",
                                        "&:hover": {
                                          backgroundColor:
                                            orderDetails.isPickedUp
                                              ? "darkgreen"
                                              : "darkorange",
                                        },
                                        "&.Mui-disabled": {
                                          backgroundColor:
                                            orderDetails.isPickedUp
                                              ? "green"
                                              : "orange",
                                          color: "white",
                                          opacity: 1,
                                        },
                                      }}
                                      startIcon={
                                        isSending ? (
                                          <CircularProgress size={14} />
                                        ) : null
                                      }
                                    >
                                      {orderDetails.isPickedUp
                                        ? "Validación Picked: físico ok"
                                        : "Requiere validar físico"}
                                    </Button>
                                  </Grid2>

                                  {orderDetailsCliente ? (
                                    <Grid2>
                                      <Button
                                        onClick={() =>
                                          HandlePrintBiccShipping(
                                            orderDetails,
                                            orderDetailsCliente
                                          )
                                        }
                                        sx={{ width: "100%", fontSize: "1em" }}
                                      >
                                        <PrintIcon fontSize="medium" />
                                        Imprimir etiqueta
                                      </Button>
                                    </Grid2>
                                  ) : null}
                                </>
                              ) : null}
                            </Grid2>
                          )}
                          <div>
                            {orderDetails.status !== 8 ? (
                              <Grid2 xs={12} sm={6} md={4} textAlign="center">
                                <Typography
                                  variant="h6"
                                  sx={{
                                    backgroundColor: "#F3F3F3",
                                    borderRadius: "5px",
                                    padding: "5px",
                                    fontWeight: "bold",
                                    color: "#333",
                                  }}
                                  className={styleState[orderDetails.intState]}
                                >
                                  {orderDetails.intState} :
                                  {
                                    translateStatesfalabbela[
                                      orderDetails.intState
                                    ]
                                  }
                                </Typography>
                              </Grid2>
                            ) : null}
                          </div>
                        </Box>
                      }
                    />

                    <CardContent>
                      {!docReady ? (
                        <SectionLoader text="Cargando formulario de edición..." />
                      ) : (
                        <Box sx={{ textAlign: "left" }}>
                          <Typography
                            variant="h5"
                            fontWeight="bold"
                            color="primary"
                          >
                            Resumen
                          </Typography>
                          <Box>
                            <ContainerViewComponent className="formcontent">
                              <EditOrderFrom
                                orderDetails={orderDetails}
                                usuarioStorage={props.usuarioStorage}
                                orderDetailsCliente={orderDetailsCliente}
                                dataOrdesBicciExpress={dataOrdesBicciExpress}
                                orderid={orderId}
                                setOrderDetails={setOrderDetails}
                              />
                            </ContainerViewComponent>
                          </Box>
                        </Box>
                      )}
                    </CardContent>
                  </Card>
                </Grid2>

                {/* Columna derecha */}
                <Grid2 sx={{ width: { xs: "100%", sm: "100%", md: "32%" } }}>
                  <Box
                    sx={{
                      maxHeight: 300,
                      overflowY: "auto",
                      backgroundColor: "#f8f8f8",
                    }}
                  >
                    <CardHeader
                      title={
                        <h3 style={{ color: "black" }}>
                          Estados de Operaciones :
                        </h3>
                      }
                    />
                    <Table size="small">
                      <TableHead>
                        <TableRow>
                          <TableCell>Fecha</TableCell>
                          <TableCell>Nombre</TableCell>
                          <TableCell>Estado Enviado</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {xlogs.map((log) => (
                          <TableRow key={log.id}>
                            <TableCell>{formatDate(log.date)}</TableCell>
                            <TableCell>{log.name || "-"}</TableCell>
                            <TableCell>
                              {translateStatesfalabbela[log.exceptionID] ||
                                log.status ||
                                "-"}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </Box>
                  <Card className="card-ultimasOrdenes typeMiniforms">
                    <CardHeader
                      title={
                        <h3>Comentarios visibles en manifiestos de rutas</h3>
                      }
                    />
                    <CardContent>
                      {!docReady ? (
                        <SectionLoader text="Cargando comentarios..." />
                      ) : (
                        <Box
                          sx={{
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                            maxWidth: "150",
                          }}
                        >
                          <ContainerViewComponent className="formcontent">
                            <hr />
                            <Typography
                              fontFamily="Lato, Arial, Helvetica, sans-serif"
                              color="textPrimary"
                              gutterBottom
                              variant="body"
                            >
                              Rider:{" "}
                            </Typography>
                            <Typography
                              fontFamily="Lato, Arial, Helvetica, sans-serif"
                              color="textPrimary"
                              gutterBottom
                              variant="body"
                            >
                              {orderDetails.observationReceptor ? (
                                <div className="color-blue">
                                  {orderDetails.observationReceptor}
                                </div>
                              ) : (
                                "Sin Comentarios"
                              )}
                            </Typography>
                            <hr />
                            Admin:
                            {orderDetails.observationAdmin &&
                            orderDetails.observationAdmin.length > 0
                              ? orderDetails.observationAdmin.map(
                                  (item, index) => (
                                    <div key={index} className="color-blue">
                                      <hr />
                                      <div>{item}</div>
                                    </div>
                                  )
                                )
                              : " Sin Comentarios"}
                            <hr />
                            Agregar comentario a la Orden
                            <div>
                              <Box
                                component="form"
                                onSubmit={saveComentAdmin}
                                sx={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: 2,
                                }}
                              >
                                <TextField
                                  placeholder="Agregar comentario"
                                  variant="outlined"
                                  type="text"
                                  fullWidth
                                  onChange={(e) => setNewComent(e.target.value)}
                                  value={newComent}
                                  InputProps={{ startAdornment: <EditIcon /> }}
                                />
                                <Button
                                  sx={{
                                    backgroundColor: "#591E8F",
                                    color: "#fff",
                                    marginTop: "30px",
                                    ":hover": {
                                      backgroundColor: "#25b2f4 !important",
                                      color: "#591e8f",
                                    },
                                  }}
                                  color="primary"
                                  variant="contained"
                                  type="submit"
                                  disabled={isSending || !newComent.trim()}
                                  startIcon={
                                    isSending ? (
                                      <CircularProgress size={14} />
                                    ) : null
                                  }
                                >
                                  Guardar Nota de Orden
                                </Button>
                              </Box>
                            </div>
                            <hr />
                            <Box sx={{ display: "flex" }}>
                              <Button
                                sx={{
                                  backgroundColor: "#591E8F",
                                  border: "none",
                                  borderRadius: "3px",
                                  color: "#fff",
                                  cursor: "pointer",
                                  fontSize: "14px",
                                  marginTop: "30px",
                                  outline: "none",
                                  padding: "5px",
                                  minWidth: "50px",
                                  fontWeight: 400,
                                  margin: "0em 1em 0em 0em",
                                  ":hover": {
                                    backgroundColor: "#25b2f4 !important",
                                    color: "#591e8f",
                                  },
                                }}
                                onClick={() => setOpenEdit(true)}
                                color="primary"
                                variant="contained"
                                type="button"
                                disabled={
                                  !companyReady ||
                                  isSending ||
                                  !compyOrder?.nonDelivery
                                }
                                startIcon={
                                  isSending ? (
                                    <CircularProgress size={14} />
                                  ) : null
                                }
                              >
                                {companyReady && compyOrder?.nonDelivery ? (
                                  "Enviar Excepción"
                                ) : (
                                  <>
                                    <CircularProgress
                                      size={12}
                                      sx={{ color: "#fff" }}
                                    />
                                    &nbsp;Cargando
                                  </>
                                )}
                              </Button>

                              <Button
                                sx={{
                                  backgroundColor: "#591E8F",
                                  border: "none",
                                  borderRadius: "3px",
                                  color: "#fff",
                                  cursor: "pointer",
                                  fontSize: "14px",
                                  marginTop: "30px",
                                  outline: "none",
                                  padding: "5px",
                                  minWidth: "50px",
                                  fontWeight: 400,
                                  margin: "0em 1em 0em 0em",
                                  ":hover": {
                                    backgroundColor: "#25b2f4 !important",
                                    color: "#591e8f",
                                  },
                                }}
                                onClick={() => setOpemPopUpAsignament(true)}
                                color="primary"
                                variant="contained"
                                type="button"
                              >
                                Asignar conductor
                              </Button>

                              <EditRoutePosition orderID={orderDetails.id} />

                              {companyReady && compyOrder?.nonDelivery ? (
                                <ReusableFormExceptions
                                  compyOrder={compyOrder}
                                  open={openEdit}
                                  handleClose={() => setOpenEdit(false)}
                                  onSave={onSave}
                                  orderID={orderDetails.id}
                                  riderDestails={
                                    riderDestails?.driverLocation
                                      ? riderDestails.driverLocation
                                      : null
                                  }
                                  user={props.firebaseUser}
                                />
                              ) : null}
                            </Box>
                            <hr />
                            <Box sx={{ mt: 1 }}>
                              <LiberarOrden
                                orderID={orderDetails.id}
                                userID={props.usuarioStorage.uid}
                                firebaseUser={props.firebaseUser}
                              />
                            </Box>
                          </ContainerViewComponent>
                        </Box>
                      )}
                    </CardContent>
                  </Card>

                  {/* Geo referencia (mantener igual) */}
                  <Card
                    className="card-ultimasOrdenes typeMiniforms"
                    sx={{ mt: 2 }}
                  >
                    <CardHeader title={<h3>Geo referencia</h3>} />
                    <CardContent>
                      <Box
                        sx={{
                          alignItems: "center",
                          display: "flex",
                          flexDirection: "column",
                          maxWidth: "350",
                        }}
                      >
                        <MapDeliveryPosition
                          markersPending={orderDetails}
                          dispachtHistory={dispachtHistory}
                          riderDestails={riderDestails}
                          isLoaded={isLoaded}
                          libraries={libraries}
                        />
                      </Box>
                    </CardContent>
                  </Card>

                  {/* Historial (independiente) */}
                  <Card
                    className="card-ultimasOrdenes typeMiniforms"
                    sx={{ mt: 2 }}
                  >
                    <CardHeader title={<h2>Historial</h2>} />
                    <CardContent>
                      {!historyReady ? (
                        <SectionLoader text="Cargando historial..." />
                      ) : (
                        <Box
                          sx={{
                            alignItems: "center",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <ContainerViewComponent
                            className="formcontent"
                            id="micuentafromIni"
                          >
                            <Table>
                              <TableHead>
                                <TableRow>
                                  <TableCell>Fecha</TableCell>
                                  <TableCell>Conductor</TableCell>
                                  <TableCell>Estado</TableCell>
                                  <TableCell>Integracion</TableCell>
                                </TableRow>
                              </TableHead>

                              {dispachtHistory.length > 0 ? (
                                <TableBody>
                                  {dispachtHistory.map((item, index) => {
                                    const driver = ridersById.get(
                                      item.driverID
                                    );
                                    if (driver) {
                                      latDriver = driver.name;
                                    }
                                    const tsMs = item?.createdAt?.seconds
                                      ? item.createdAt.seconds * 1000
                                      : typeof item?.createdAt?.toMillis ===
                                        "function"
                                      ? item.createdAt.toMillis()
                                      : Date.now();

                                    return (
                                      <TableRow key={item.id || index}>
                                        <TableCell>
                                          {format(tsMs, "dd/MM/yy HH:mm:ss")}
                                        </TableCell>
                                        <TableCell>
                                          {item.driverID
                                            ? driver
                                              ? driver.name
                                              : item.driverID
                                            : "Sistema"}
                                        </TableCell>
                                        <TableCell>
                                          {
                                            translateStatesBicciFilter[
                                              item.status
                                            ]
                                          }
                                        </TableCell>
                                        <TableCell>
                                          {
                                            translateStatesfalabbela[
                                              item.status
                                            ]
                                          }
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              ) : (
                                <TableBody>
                                  <TableRow>
                                    <TableCell colSpan={4} align="center">
                                      No hay historial disponible
                                    </TableCell>
                                  </TableRow>
                                </TableBody>
                              )}
                            </Table>
                          </ContainerViewComponent>
                        </Box>
                      )}
                    </CardContent>
                  </Card>
                </Grid2>
              </Grid2>
            </Grid2>
          </div>
        </>
      ) : (
        <>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Esperando información</h5>
              {findOrder ? (
                "No se encontró información..."
              ) : (
                <>
                  {findOrder === false ? (
                    <p className="card-text">
                      No se encontraron resultados{" "}
                      <span
                        role="img"
                        aria-label="Nerd face"
                        className="bigFace"
                      >
                        😕
                      </span>{" "}
                      que coincidan con su búsqueda, verifique el código o
                      consulte si la orden fue creada correctamente
                      <br />
                      <span
                        role="img"
                        aria-label="Nerd face"
                        className="bigFace"
                      >
                        🤓
                      </span>
                    </p>
                  ) : (
                    <>
                      <img
                        src="/static/images/asset/enapuros.webp"
                        alt="Buscando..."
                        width="70"
                      />{" "}
                      Buscando...
                    </>
                  )}
                </>
              )}
              <hr />
              <button
                type="button"
                className="btn btn-ebiex m-1"
                onClick={handleClick}
              >
                Regresar
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default EditDispatchdetails;
